import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';
import getters from './getters';

// import helper from '@/core/helper';

const state = {
  campaigns: [],
  campaign: {},
  permissions: new Map(),
  campaignProperties: {},
  campaignStats: {},
  campaignChanges: {},
  order: {},
  orderChanges: {},
  existingAdvertisers: [],
  selectedAdvertiser: {},
  contentProviderId: 0,
  contentProviderName: '',
  countries: {},
  regions: [],
  regionsMap: [],
  agencies: [],
  blacklist: {},
  currencies: [],
  linkingWords: [],
  publisherList: [],
  publisherListMap: [],
  publisherIds: [],
  selectedPublisherGroups: [],
  campaignStates: [],
  isLoading: false,
  adxAdvertisers: [],
  dealOverrides: [],
  viewType: '',
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
